import dayjs from 'dayjs';
import {
  DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_TIME_FORMAT,
  DISPLAY_LOG_DATE_TIME_FORMAT,
  INVALID_DATE_MESSAGE,
  SERVER_DATE_FORMAT,
} from '@shared/constants/date';

export const DISPLAY_DATE_VARIANTS = {
  DATE: 'date',
  DATE_TIME: 'dateTime',
  LOG: 'log',
};

const FORMAT_BY_VARIANT = {
  [DISPLAY_DATE_VARIANTS.DATE]: DISPLAY_DATE_FORMAT,
  [DISPLAY_DATE_VARIANTS.DATE_TIME]: DISPLAY_DATE_TIME_FORMAT,
  [DISPLAY_DATE_VARIANTS.LOG]: DISPLAY_LOG_DATE_TIME_FORMAT,
};

/**
 * Convierte una fecha a un string con el formato usado para mostrar en la interfaz.
 *
 * @param {string | number | Date | dayjs.Dayjs} date Fecha de entrada.
 * @param {object} [options] Opciones adicionales.
 * @param {'date' | 'dateTime' | 'log'} [options.variant='date'] Variante de formato de visualización.
 * @returns {string} Fecha formateada, string vacío si no hay fecha, o mensaje de error si no es válida.
 */
export const formatDateForDisplay = (date, { variant = DISPLAY_DATE_VARIANTS.DATE } = {}) => {
  const format = FORMAT_BY_VARIANT[variant];
  if (!format) {
    throw new Error(`Unknown display date variant: ${variant}`);
  }

  if (!date) return '';

  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) return INVALID_DATE_MESSAGE;

  return dayjsDate.format(format);
};

/**
 * Convierte una fecha a un string con el formato requerido por el backend.
 *
 * @param {string | number | Date | dayjs.Dayjs} date Fecha de entrada.
 * @returns {string} Fecha formateada en 'YYYY-MM-DD' o un string vacío si la fecha no es válida.
 */
export const formatDateForServer = (date) => {
  if (!date) return '';

  const dayjsDate = dayjs(date);
  return dayjsDate.isValid() ? dayjsDate.format(SERVER_DATE_FORMAT) : '';
};
